import { useI18n } from 'vue-i18n'

import useBlProviders from '@/composables/providers/useBlProvider'
import MaterialsTagsDT from '@/services/dataTransferModules/materialsTagsDt'
const materialsTagsDt = new MaterialsTagsDT()

export default function useMaterialsTags() {
	const { t: $t } = useI18n()

	const {
		loadEntityFlags: flags,

		entities: materialsTags,
		getEntities: getMaterialsTags,

		hashedBasedEntities: hashedBasedMaterialsTags,
		getHashedBasedEntities: getHashedBasedMaterialsTags,

		createEntity: createMaterialsTags,

		entity: materialsTag,
		getEntity: getMaterialsTag,

		entityPreview: materialsTagsPreview,
		getEntityPreview: getMaterialsTagsPreview,

		patchEntity: updateMaterialsTags,
		updateEntity: fullUpdateMaterialsTags,

		deleteEntity: deleteMaterialsTags,
	} = useBlProviders(materialsTagsDt, {
		hasParentEntity: true,

		showErrorNotificationForLoadingAllEntities: true,
		errorNotificationTextForLoadingAllEntities: $t('Materials tags loaded with an error!'),
		showErrorNotificationForCreatingEntity: true,
		errorNotificationTextForCreatingEntity: $t('Error loading new materials tag'),
		showErrorNotificationForLoadingOneEntity: true,
		errorNotificationTextForLoadingOneEntity: $t('Materials tag loading error'),
		showErrorNotificationForUpdatingEntity: true,
		errorNotificationTextForUpdatingEntity: $t('Error loading materials tag'),
	})

	return {
		flags,
		materialsTags,
		hashedBasedMaterialsTags,
		materialsTagsPreview,
		materialsTag,

		getMaterialsTags,
		getHashedBasedMaterialsTags,
		getMaterialsTagsPreview,
		getMaterialsTag,
		createMaterialsTags,
		deleteMaterialsTags,
		updateMaterialsTags,
		fullUpdateMaterialsTags,
	}
}
